"use client";

import React, { useState, useEffect } from "react";
import { ArrowRight } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Link } from "@/components/common/Link";
const slideshowImages = [{
  src: "https://turtorteknik.com/wp-content/uploads/2026/05/Novosprint_Syncro_3-scaled.png?v=l80oie8n45",
  srcset: "https://turtorteknik.com/wp-content/uploads/2026/05/Novosprint_Syncro_3-scaled.png?v=ng1uqfcm4vl-wvc-srcset",
  sizes: "https://turtorteknik.com/wp-content/uploads/2026/05/Novosprint_Syncro_3-scaled.png?v=7gld1105dqk-wvc-sizes",
  alt: "HT Series Güvenlik Kapısı"
}, {
  src: "https://turtorteknik.com/wp-content/uploads/2026/05/hangar_02-2.png?v=hynwjru0mtl",
  srcset: "https://turtorteknik.com/wp-content/uploads/2026/05/hangar_02-2.png?v=vvyqelow6a-wvc-srcset",
  sizes: "https://turtorteknik.com/wp-content/uploads/2026/05/hangar_02-2.png?v=vr39egait3-wvc-sizes",
  alt: "Teleskop Prensibi Uçak Hangar Kapısı"
}, {
  src: "https://turtorteknik.com/wp-content/uploads/2026/05/Spacelite_HT150_4-scaled.png?v=tknugjrecl",
  srcset: "https://turtorteknik.com/wp-content/uploads/2026/05/Spacelite_HT150_4-scaled.png?v=lhw1p02tcri-wvc-srcset",
  sizes: "https://turtorteknik.com/wp-content/uploads/2026/05/Spacelite_HT150_4-scaled.png?v=goitindy5g-wvc-sizes",
  alt: "SPACELITE- HT Serisi Seksiyonel Kapı"
}, {
  src: "https://turtorteknik.com/wp-content/uploads/2026/05/STORM.png?v=jm51a0qisn",
  srcset: "https://turtorteknik.com/wp-content/uploads/2026/05/STORM.png?v=0uokcg3g1ri-wvc-srcset",
  sizes: "https://turtorteknik.com/wp-content/uploads/2026/05/STORM.png?v=y2unlhhxob-wvc-sizes",
  alt: "NOVOSPRINT Syncro L/XL Hızlı Sarmal Kapı"
}];
export default function TransformDreamsIntoPaper() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentImageIndex(prevIndex => (prevIndex + 1) % slideshowImages.length);
    }, 4000);
    return () => clearInterval(timer);
  }, []);
  return <section data-section-id="222285" id="butzbach-endüstriyel-kapı-sistemleri" className="bg-background text-foreground relative overflow-hidden py-12 lg:py-20 flex items-center" ref={sectionRef}>
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-[20%] -right-[10%] w-[60%] h-[60%] rounded-md bg-primary/5 blur-[120px]" />
        <div className="absolute -bottom-[20%] -left-[10%] w-[50%] h-[50%] rounded-md bg-secondary/10 blur-[120px]" />
        <div className="absolute inset-0 opacity-[0.03] bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672977/img/graphy.png')]" />
      </div>

      <div className="relative z-10 w-full">
        <div className="relative w-full h-[420px] sm:h-[500px] lg:h-[600px] overflow-hidden bg-card">
          {}
          {slideshowImages.map((image, index) => <img key={index} data-index={index} src={image.src} data-wvc-srcset={image.srcset} data-wvc-sizes={image.sizes} alt={image.alt} loading={index === 0 ? "eager" : "lazy"} className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-1000 ease-in-out ${currentImageIndex === index ? "opacity-100" : "opacity-0 pointer-events-none"}`} />)}

          {}
          <div className="absolute inset-0 bg-gradient-to-r from-background from-10% via-background/70 via-40% to-transparent pointer-events-none z-[5]" />

          {}
          <div className="relative z-10 max-w-xl px-6 sm:px-10 lg:px-16 py-12 flex flex-col items-start justify-center h-full">
            <div className={`transition-all duration-1000 ease-out transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
            transitionDelay: "100ms"
          }}>
              <Badge variant="outline" className="mb-4 sm:mb-6 border-primary/40 text-primary px-3.5 py-1 text-xs sm:text-sm rounded-md backdrop-blur-md bg-background/70 uppercase tracking-widest font-default font-semibold">
                Resmi Türkiye Temsilcisi
              </Badge>
            </div>

            <h1 className={`font-default text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold leading-[1.1] tracking-tighter mb-4 sm:mb-6 transition-all duration-1000 ease-out transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
            transitionDelay: "200ms"
          }}>
              TÜR TOR{" "}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary via-primary to-primary/60 pr-2">
                TEKNİK
              </span>{" "}
              <br className="hidden sm:inline" />
              Güvencesiyle.
            </h1>

            <p className={`text-sm sm:text-base md:text-lg text-muted-foreground mb-6 sm:mb-8 max-w-lg leading-relaxed transition-all duration-1000 ease-out transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
            transitionDelay: "300ms"
          }}>
              Butzbach GMBH resmi temsilcisi olarak, 25 yılı aşkın tecrübemizle endüstriyel kapı sistemlerinde satış, teknik servis, periyodik bakım ve orijinal yedek parça tedariği sağlıyoruz.
            </p>

            <div className={`transition-all duration-1000 ease-out transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
            transitionDelay: "400ms"
          }}>
              <div className="flex flex-wrap gap-3 sm:gap-4">
                <Button asChild size="lg" className="rounded-md bg-primary text-primary-foreground hover:bg-primary/90 text-sm sm:text-base px-6 sm:px-8 py-5 sm:py-6 shadow-lg shadow-primary/20 transition-all duration-300 hover:scale-105 hover:-translate-y-0.5 group">
                  <Link to="/ShopPage">
                    Çözümleri Keşfedin
                    <ArrowRight className="ml-2 size-4 sm:size-5 transition-transform duration-300 group-hover:translate-x-1" />
                  </Link>
                </Button>
                <Button asChild variant="outline" size="lg" className="rounded-md border-border bg-background/70 backdrop-blur-sm hover:bg-accent text-sm sm:text-base px-6 sm:px-8 py-5 sm:py-6 transition-all duration-300">
                  <Link to="/MaintenanceAndRepairPage">
                    Teknik Destek
                  </Link>
                </Button>
              </div>
            </div>
          </div>

          {}
          <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex items-center gap-2.5 z-20">
            {slideshowImages.map((_, dotIndex) => <Button key={dotIndex} data-index={dotIndex} type="button" onClick={() => setCurrentImageIndex(dotIndex)} aria-label={`Slayt ${dotIndex + 1}`} className={`h-2.5 p-0 min-w-0 border-0 rounded-md transition-all duration-300 ${currentImageIndex === dotIndex ? "w-8 bg-primary hover:bg-primary" : "w-2.5 bg-muted hover:bg-muted-foreground/40"}`} />)}
          </div>
        </div>
      </div>
    </section>;
}